module.exports = __webpack_public_path__ + "static/img/pool page top img_mobile.35c7e49d.jpg";